<template>
  <div>
    <span class="breadcrumb" @click="navigate(-1)" >
      Fichiers
    </span>
    <span v-for="(node, i) in path" :key="node.id" class="breadcrumb" @click="navigate(i)" >
      {{ node.name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      path: this.value
    }
  },
  watch: {
    value () {
      this.path = this.value
    }
  },
  methods: {
    navigate (index) {
      this.path.splice(index + 1, this.path.length)
      this.$emit('input', this.path)
    }
  }
}
</script>

<style scoped>
.breadcrumb {
    cursor: pointer;
}
.breadcrumb::Before {
    content: "/";
}
</style>



// WEBPACK FOOTER //
// src/files/components/PathBreadcrumbs.vue